<template>
    <div >

        <tq-image v-for="index_n in numberOfStars_n"
             :pb_src_r="m_getStar_fr(index_n)"
             class="TQ_inline TQ_padding_2px"
             :style="{'width' : p_starsWidth_s, 'margin' : p_starsMargin_s}"
             @mousemove.native="m_hoverRating_f($event, index_n)"
             @mouseleave.native="m_mouseleave_f"
             @click.native="m_changeRating_f($event, index_n)"
        />


    </div>
</template>

<script>
    import {ass_img_empty_star, ass_img_half_star, ass_img_star} from "../../assets/scripts/Ass_Files";
    import TqImage from "@/components/basic/TqImage";

    export default {
        name: "si_Stars",
        components: {TqImage},
        props: {
            rating:{
                type: Number,
                require: true,
            },
            p_starsWidth_s:{
                type:String,
                default: "16px"
            },
            p_starsMargin_s:{
                type:String,
                default: "0"
            },
            pe_changeRating_f:{
                type:Function
            }

        },
        data(){
            return {
                numberOfStars_n: 5,
                hoverRating_n: null,
            }
        },
        methods:{
            m_getStar_fr(index_n) {

                let rating_n = this.hoverRating_n > this.rating ? this.hoverRating_n  : this.rating

                rating_n = rating_n - index_n


                if(rating_n > -1){
                    return ass_img_star
                }
                return ass_img_empty_star


            },
            m_hoverRating_f(event, index_n){
                if(this.pe_changeRating_f == null) return

                this.hoverRating_n =  index_n
            },
            m_mouseleave_f(){
                if(this.pe_changeRating_f == null) return
                this.hoverRating_n =  null
            },
            m_changeRating_f(event, index_n){
                if(this.pe_changeRating_f == null) return
                this.pe_changeRating_f(index_n)
            }
        }
    }
</script>

<style scoped>



</style>
